import { ChangeEvent, Dispatch, useEffect, useState } from 'react';
import Triangle from '../../icons/Triangle';

interface MinimumSalarySliderProps {
  options: string[];
  onChange: (value: string) => void;
  selectedFilters: string[];
  setSelectedFilters: Dispatch<string[]>;
}

const MinimumSalarySlider: React.FC<MinimumSalarySliderProps> = ({
  options,
  selectedFilters,
  setSelectedFilters,
}) => {
  const [value, setValue] = useState(0);

  const handleChange = (event: ChangeEvent | null, val?: number) => {
    const target = event?.target as HTMLInputElement;
    const newVal = Number(target?.value) || val || 0;
    setSelectedFilters([options[newVal]]);
  };

  useEffect(() => {
    const index = options.findIndex((opt) => opt == selectedFilters[0]);
    setValue(index != -1 ? index : 0);
  }, [selectedFilters]);

  return (
    <div className="mx-5 my-20">
      <div className="relative mx-8">
        <input
          className="z-30 w-full bg-transparent appearance-none"
          list="minimumSalarySlider"
          type="range"
          min={0}
          max={options.length - 1}
          step={1}
          value={value}
          onChange={handleChange}
        />
        <div
          className="bg-primary h-[9px] md:h-[5px] absolute right-0 top-[9px] md:top-[12px] z-20"
          style={{
            width: `${
              ((options.length - value - 1) / (options.length - 1)) * 100
            }%`,
          }}
        ></div>
        <div className="bg-gray h-[9px] md:h-[5px] absolute right-0 top-[9px] md:top-[12px] z-10 w-full"></div>
        <Triangle className="h-[29px] w-[33px] fill-primary absolute -right-7 top-0 -z-0" />
        <div className="absolute -top-[30px] flex w-full my-8 md:hidden justify-between">
          {options.map((option, index) => (
            <div
            key={`${option}-${index}`}
              tabIndex={1}
              onClick={() => handleChange(null, index)}
              className={`h-[25px] w-[2px] ${
                value > index ? 'bg-gray' : 'bg-primary'
              }`}
            ></div>
          ))}
        </div>
      </div>
      <ul className="hidden w-full my-8 md:flex justify-evenly">
        {options.map((option, index) => (
          <li
            tabIndex={1}
            onClick={() => handleChange(null, index)}
            className={`flex-1 text-sm font-bold text-center ${
              value > index ? 'text-gray9' : 'text-primary'
            }`}
            key={`option-${option}`}
          >
            {option}
          </li>
        ))}
      </ul>

      <p className="block w-full my-10 text-lg font-bold text-center md:hidden text-primary">
        {options[value]}
      </p>
    </div>
  );
};

export default MinimumSalarySlider;
